import FormValidation from "../../Validation/FormValidation";
import '@nobleclem/jquery-multiselect';

const Select = {

    bind(form) {
        this.input = 'select';
        form.find(this.input).on('change', (evt) => {
            FormValidation.setValid($(evt.currentTarget), this.isValid($(evt.currentTarget)));
            this.fillHiddenInputs($(evt.currentTarget));
        });

        this.selectIfOnlyOneExist(form);
    },

    selectIfOnlyOneExist(form) {
        form.find(this.input).each((i, el) => {
            const options = $(el).find('option').filter("[value!='']");
            if (options.length === 1) {
                $(el).val(options.val());
                $(el).trigger('chosen:updated');
                this.fillHiddenInputs($(el));
            }
        })
    },

    check(form) {
        let ok = true;
        form.find(this.input).each((i, el) => {
            ok = ok && this.isValid($(el));
            FormValidation.setValid($(el), ok, true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.closest('.input').is('.required');
        if (isRequired) return !!input.val()
        else return true;
    },

    fillHiddenInputs(el) {
        const selectName = el.attr('name');
        const selected = el.find(':selected');
        const nameInput = el.prevAll('[name="' + selectName + '_name"]');
        const iconInput = el.prevAll('[name="' + selectName + '_icon"]');

        nameInput && nameInput.val(selected.text());
        iconInput && iconInput.val(WEB_ROOT + '/templates/src/Assets/icons/png/icon.' + selected.attr('icon') + '.png');
    }
}

export default Select;
